import I18n from '@utils/i18n.utils';

export enum DocumentKind {
  EXECUTION = 'EXECUTION',
  ISSUE = 'ISSUE',
  CLIENT_INVOICE = 'CLIENT_INVOICE',
  SUPPLIER_INVOICE = 'SUPPLIER_INVOICE',
  CREDIT_NOTE = 'CREDIT_NOTE',
  USER_PROFILE_PICTURE = 'USER_PROFILE_PICTURE',
  COMPANY_PICTURE = 'COMPANY_PICTURE',
  DIVERSE = 'DIVERSE',
  AUDIT = 'AUDIT'
}

export namespace DocumentKind {
  export const selectItems = () => [
    { label: I18n.t('global.documentKind.clientInvoice'), value: DocumentKind.CLIENT_INVOICE },
    { label: I18n.t('global.documentKind.supplierInvoice'), value: DocumentKind.SUPPLIER_INVOICE },
    { label: I18n.t('global.documentKind.creditNote'), value: DocumentKind.CREDIT_NOTE },
  ].sort((a, b) => a.label.localeCompare(b.label))
    .concat({ label: I18n.t('global.documentKind.diverse'), value: DocumentKind.DIVERSE });
}

export interface DocumentInfo {
  id: number;
  name: string;
  description: string;
  documentKind: string;
  filename: string;
  mimetype: string;
  file?: File;
}
